import { Button, Col, DatePicker, Form, Input, InputNumber, List, Modal, notification, Popconfirm, Row, Select, Space, Typography, Upload, UploadProps } from "antd";
import moment from "moment";
import { useCallback, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { DOUBLE_REGEX, NUMBER_REGEX, SPACE_REGEX } from "shared/constants/AppConstants";
import { RootState } from "shared/redux/store";
import API_SERVICE from "shared/services/api-service";
import { getEnumList, numberWithCommas } from "shared/services/Utility";
import { ReactComponent as IconAction } from "../../../../../assets/images/action.svg";
import { ReactComponent as IconDelete } from "../../../../../assets/images/delete.svg";
import AppUpload from "shared/components/Lead/AppUpload/app-upload";
import LoaderOverlay from "shared/LoaderOverlay";
import AppLoading from "shared/components/AppLoading/AppLoading";

const {Text} = Typography

interface IAddorEditDisbursed {
    finalLender: any;
    setFinalLander: any;
    setIsAddClick: (value: boolean) => void;
    setIsLoading: (value: boolean) => void;
    calcTotalDisbursedAmount: any;
    leadData: any;
    onActionSubmit: any,
    setIsAddCheck: (value: boolean) => void;
    setAddBtnErr: any;
    productPlanName:any;
    setProductPlanName:any
    productPlanId:any;
    setLimit:any,
    setAnnualFee:any
}

// Debounce utility
function useDebounce(fn, delay) {
    const timeoutRef = useRef<any>();
    const fnRef = useRef(fn);
    fnRef.current = fn;
    return useCallback((...args) => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            fnRef.current(...args);
        }, delay);
    }, [delay]);
}

const AddDisbursed: React.FC<IAddorEditDisbursed> = (props: IAddorEditDisbursed) => {

    const {
        finalLender,
        setFinalLander,
        setIsAddClick,
        setIsLoading,
        calcTotalDisbursedAmount,
        leadData,
        onActionSubmit,
        setIsAddCheck,
        setAddBtnErr,
        productPlanName, 
        setProductPlanName,
        productPlanId,
        setLimit,
        setAnnualFee
    } = props;
    const [fileList, setFileList] = useState([] as any);
    // const [imageUrl, setImageUrl] = useState(null as any);
    const [finalValue, setFinalValue] = useState(null as any);
    const [fileSize, setFileSize] = useState(null as any);
    const [showConfirmationPayout, setShowConfirmationPayout] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null as any);
    const [isUploaded, setIsUploaded] = useState(false)
    const [disbursedForm] = Form.useForm() as any;
    const { appColors, isMobile }: any = useSelector((state: RootState) => state.common);
    const isTenantWorkingCapitalEnabled = localStorage.getItem("tenantWorkingCapitalEnabled") == 'true' ? true : false;
    const isDocumentMendatory = finalLender?.shouldDocumentBeMandatoryBasedOnPAPQ
    const payoutType = leadData?.caseDetails?.connectorDetails?.payoutType;
    const [applicationNumber, setApplicationNumber] = useState("")
    const checkTenativePayout = leadData?.caseDetails?.connectorDetails?.payoutPercentage;
    const [tenativePayoutFromAPI, setTenativePayoutFromAPI] = useState<number | null>(null);
    const [payoutTypeFromAPI, setPayoutTypeFromAPI] = useState<string | null>(null);    
    const customStylesSubmitBtnPrimary: any = {
        '--btnColor': appColors?.appPrimaryColor ?? "",
        'width': "150px",
        'borderRadius': "9px",
        'marginBottom': "10px",
    };
    const disableDate = (current) => {
        let sanctionedDate = finalLender?.sanctionedDate;
        if(leadData?.loanType === "Credit Card"){
            return current && current.isBefore(sanctionedDate, 'day');
        }
        else{
        if ((sanctionedDate?.length ?? 0) > 0) {
            return current?.isAfter(moment()) || current?.isBefore(moment(sanctionedDate));
        }
        return current?.isAfter(moment()?.subtract(0, "day"))
        }
    };

    const [payoutDetails, setPayoutDetails] = useState<any>(null);
    const [loaderForPayout, setLoaderForPayout] = useState<any>(null);

    const fetchPayoutDetails = useCallback(async (disbursementDateParam?: string) => {
        setLoaderForPayout(true);
        const connectorId = leadData?.caseDetails?.connectorDetails?.userDetails?.id;
        const loanProductId = leadData?.loanProductId;
        const disbursementDate = disbursementDateParam ?? finalLender?.disbursalLenderInfoDetails[0]?.lenderAmount?.disbursalDate;
        // Pass requestedDisbursalAmount if available
        const requestedDisbursalAmount = finalLender?.disbursalLenderInfoDetails[0]?.lenderAmount?.requestedDisbursalAmount;
        try {
            const { data } = await API_SERVICE.getPayoutDisbursementDetails({
                id: connectorId,
                forConnector: true,
                status: "ACTIVE",
                loanProductId,
                disbursementDate,
                requestedDisbursalAmount,
                lenderBusinessId: finalLender?.lenderInfoId,
            });
            setPayoutDetails(data?.payload);
            setTenativePayoutFromAPI(data?.payload?.value);
            setPayoutTypeFromAPI(data?.payload?.payoutType);
            setLoaderForPayout(false);
        } catch (e) {
            setPayoutDetails(null);
            disbursedForm.setFieldsValue({ payoutPercentage: 0 });
            setLoaderForPayout(false);
        }
    }, [leadData?.caseDetails?.connectorDetails?.userDetails?.id, leadData?.loanProductId, finalLender?.disbursalLenderInfoDetails]);

    // Debounced fetchPayoutDetails
    const debouncedFetchPayoutDetails = useDebounce(fetchPayoutDetails, 2000);

    useEffect(() => {
        setIsAddCheck(true);
        setAddBtnErr('Please fill current disbursement details before adding a disbursement');
        disbursedForm.setFieldsValue({
            disbursedBy: "LENDER",
        });
        fetchPayoutDetails();
    }, []);

    useEffect(()=>{
        setIsLoading(true);
        const prodPlanData = leadData.caseDetails.lenderActivityHolder.lenderActivityDetails
        ?.flatMap(item => item.subProductDetails?.subProductDetails || []);;
        const cardRelatedData = prodPlanData?.find((item) => item?.productPlanId === productPlanId)
        let payload = {
            lenderIds: finalLender?.lenderInfoId,
            loanProductId: leadData?.loanProductId,
            status: "ACTIVE"
        };
        API_SERVICE.getLenderListInsurer(payload)
            .then(({ data }) =>{
            let cardDetails = data?.payload
            ?.flatMap((lender) => lender.productPlanDetails || [])
            .find((plan) => plan.productPlanId === productPlanId);
             setProductPlanName(cardDetails?.productPlanName)  
           
            }) 
            .catch((e: any) => {
                notification.error({ message: API_SERVICE.handleErrors(e) });
            })
            .finally(() => setIsLoading(false));
            setApplicationNumber(cardRelatedData?.applicationNumber)
            setLimit(cardRelatedData?.limit)
            setAnnualFee(cardRelatedData?.annualFee)
            disbursedForm.setFieldsValue({
                cardIssuedDate: cardRelatedData?.cardIssuedDate
                ? moment(cardRelatedData?.cardIssuedDate)
                : null
            }); 
        // }
    },[productPlanId])

    useEffect(() => {
            // const value = payoutDetails?.value !== undefined ? payoutDetails?.value : payoutPercentage;
            const value = payoutDetails?.value;
            if (value !== undefined && value !== null) {
                disbursedForm.setFieldsValue({ payoutPercentage: value });
            }
    }, [payoutDetails]);

    const payoutPercentage =
    leadData?.caseDetails?.connectorDetails?.payoutType == 'FIXED'
      ? leadData?.caseDetails?.connectorDetails?.payoutPercentage
      ?? leadData?.caseDetails?.connectorDetails?.initialPayoutAmount
      : leadData?.sourceOfCase == 'CONNECTOR'
        ? leadData?.caseDetails?.loanDetails?.expectedInterestRate
        : null
    const data = [
        <Form.Item
            name="insuranceAmount"
            label="Insurance Amount"
            className="decision-item"
            rules={[
                {
                    required: true,
                    message: "Please enter amount",
                },
                () => ({
                    validator(_, value) {
                        if (!value && value != 0) {
                            return Promise.reject();
                        }
                        if (isNaN(value) || value < 0) {
                            return Promise.reject(
                                "Please enter valid amount"
                            );
                        }
                        return Promise.resolve();
                    },
                }),
            ]}
        >
            <InputNumber
                onChange={(ev) => {
                    finalLender.disbursalLenderInfoDetails[0].lenderAmount.insuranceAmount = ev;
                }}
                className="custom-input-number"
                formatter={(value) => numberWithCommas(value)}
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                name="insuranceAmount"
                placeholder="Insurance Amount"
            />
        </Form.Item>,
        <Form.Item
            name="disbursedAmount"
            label="Disbursed Amount"
            className="decision-item"
            rules={[
                {
                    required: true,
                    pattern: NUMBER_REGEX,
                    message: "Please enter amount"
                },
                () => ({
                    validator(_, value) {
                        let amountDisbursed =
                            finalLender?.disbursalLenderInfoDetails.map((item) =>
                                Number(item.lenderAmount.disbursedAmount)
                            );
                        const totalDisbursed = amountDisbursed.reduce(
                            (a, b) => a + b,
                            0
                        );
                        const total = totalDisbursed;
                        if (!value && value != 0) {
                            return Promise.reject();
                        }
                        if (isNaN(value) || value < 0) {
                            return Promise.reject(
                                "Please enter valid amount"
                            );
                        }
                        calcTotalDisbursedAmount(
                            finalLender?.disbursalLenderInfoDetails
                        );
                        const availbleAmount =
                            finalLender.sanctionedAmount - (total - value);
                        let to = total - value
                        if (value > availbleAmount) {
                            return Promise.reject(
                                `Please enter less amount than ${availbleAmount}`
                            );
                        }
                        return Promise.resolve();
                    },
                }),
            ]}
        >
            <InputNumber
                onChange={(ev) => {
                    finalLender.disbursalLenderInfoDetails[0].lenderAmount.disbursedAmount = ev;
                    finalLender.disbursalLenderInfoDetails[0].lenderAmount.requestedDisbursalAmount = ev;
                    debouncedFetchPayoutDetails();
                    calcTotalDisbursedAmount(finalLender?.disbursalLenderInfoDetails)
                }}
                className="custom-input-number"
                formatter={(value) => numberWithCommas(value)}
                parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                name="disbursedAmount"
                placeholder="Disbursed Amount"
            />
        </Form.Item>,
        <Form.Item
            name="disbursalDate"
            label="Disbursed Date"
            className="decision-item"
            rules={[{ required: isTenantWorkingCapitalEnabled, message: "Please Select Disbursal Date" }]}
        >
            <DatePicker
                onChange={async (ev) => {
                    const disbursalDate = ev ? moment(ev).format("YYYY-MM-DD").toString() : "";
                    finalLender.disbursalLenderInfoDetails[0].lenderAmount.disbursalDate = disbursalDate;
                    await fetchPayoutDetails(disbursalDate); // Pass selected date
                }}
                disabledDate={disableDate}
                style={{
                    width: isMobile ? '170px' : '98%',
                    marginLeft: "3px",
                    marginBottom: "5px",
                }}
                format={"YYYY-MM-DD"}
                className="custom-input"
                placeholder="Disbursal Date"
            />
        </Form.Item>,
        <Form.Item
            className="decision-item"
            label="Disbursal By"
            name="disbursedBy"
            initialValue={"Lender"}
            rules={[
                {
                    required: isTenantWorkingCapitalEnabled,
                    message: "Please Select Disbursal By"
                }
            ]}
        >
            <Select
                className="custom-select"
                onSelect={(ev: any) => {
                    finalLender.disbursalLenderInfoDetails[0].lenderAmount.disbursedBy = ev;
                }}
                
            >
                {getEnumList("DISBURSED_BY")?.map((item: any) => (
                    <Select.Option value={item?.key}>
                        {item?.value}
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>,
        <Form.Item
            name="lenderUniqueIdentifier"
            label="Lender Identifier"
            className="decision-item"
            rules={[
                {
                    required: isTenantWorkingCapitalEnabled,
                    pattern:SPACE_REGEX,
                    message: "Please enter Lender Identifier",
                },
            ]}
        >
            <Input
                size="large"
                className="custom-input"
                onChange={(ev) => {
                    finalLender.disbursalLenderInfoDetails[0].lenderAmount.lenderUniqueIdentifier = ev?.target?.value;
                }}
                placeholder="Lender Identifier"
            />
        </Form.Item>,
        <>
            <p style={{ fontSize: "12px", margin: "0", color: "#000000a6" }}>
                {(isTenantWorkingCapitalEnabled || isDocumentMendatory) && (<span style={{ color: "red" }}>*</span>)}
                &nbsp;
                Upload Disbursal Proof</p>
            {isUploaded ? (
                <Space>
                    <p style={{ fontSize: "12px", margin: "0", width: "100px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{uploadedFile?.fileName}</p>
                    <Popconfirm
                        placement="topRight"
                        okButtonProps={{ style: { backgroundColor: appColors?.appPrimaryColor ?? "#273896", border: "none" } }}
                        cancelButtonProps={{ style: { borderColor: appColors?.appSecondaryColor ?? "#C71C8E", color: appColors?.appSecondaryColor ?? "#C71C8E" } }}
                        title={"Sure to delete document?"}
                        onConfirm={(event) => {
                            setUploadedFile(null);
                            setIsUploaded(false);
                            finalLender.disbursalLenderInfoDetails[0].lenderAmount.proofOfDisbursalDto = null;
                        }}
                    >
                        <IconDelete style={{ cursor: "pointer" }} />
                    </Popconfirm>
                </Space>
            ) : (
                <AppUpload
                    acceptType={["pdf", "jpeg", "jpg", "png", "svg"]}
                    className=""
                    callBack={(response) => {
                        if ((response?.businessDocumentId?.length ?? 0) > 0) {
                            setUploadedFile(response);
                            setIsUploaded(true);
                        }
                    }}
                    multiple={false}
                    maxSize={10}
                    documentSetId={leadData?.caseDetails?.documentSetId}
                    setFileSize={setFileSize}
                    setUploadedFile={setUploadedFile}
                    setIsSelectedLenderDoc={false}
                    children={(
                        <Button style={{ color: "black" }}>Choose File</Button>
                    )}
                />
            )}
            <p style={{ fontSize: "8px", margin: "0", color: "#000000a6" }}>
                {((isTenantWorkingCapitalEnabled || isDocumentMendatory) && !isUploaded) && (<span style={{ color: "red", fontSize:"12px" }}>Please upload disbursal proof</span>)}
            </p>
        </>
        ,
        leadData?.sourceOfCase === "CONNECTOR" && (
            <Form.Item
                style={{ paddingLeft: isMobile ? '10px' : '', width: isMobile ? 'auto' : '' }}
                name="payoutPercentage"
                label={((payoutDetails?.payoutSubtype?.toUpperCase() === "AMOUNT")) ? "Payout (₹)" : "Payout %"}
                className="decision-item"
                // initialValue={payoutPercentage ? payoutPercentage : payoutDetails?.value}
                initialValue={payoutDetails?.value}
                rules={[
                    {
                        required: true,
                        message: ((payoutDetails?.payoutSubtype?.toUpperCase() === "AMOUNT")) ? "Please enter payout amount" : "Please enter payout%",
                    },
                    ((payoutDetails?.payoutSubtype?.toUpperCase() === "AMOUNT"))
                        ? {
                            pattern: NUMBER_REGEX,
                            message: "Please enter valid payout amount",
                        }
                        : {
                            pattern: DOUBLE_REGEX,
                            message: "Please enter valid payout%",
                        },
                    () => ({
                        validator(_, value) {
                            if (!value && value != 0) {
                                return Promise.reject();
                            }
                            if (isNaN(value)) {
                                return Promise.reject(
                                    ((payoutDetails?.payoutSubtype?.toUpperCase() === "AMOUNT"))
                                        ? "Please enter valid payout amount"
                                        : "Please enter valid payout %"
                                );
                            }
                            if (payoutDetails?.payoutSubtype?.toUpperCase() === "PERCENTAGE" && (value < 0 || value > 100)) {
                                return Promise.reject("Percentage must be between 0 and 100");
                            }
                            if (((payoutDetails?.payoutSubtype?.toUpperCase() === "AMOUNT")) && value < 0) {
                                return Promise.reject("Amount must be greater than 0");
                            }
                            return Promise.resolve();
                        },
                    }),
                ]}
            >
                <InputNumber
                    onChange={(ev: any) => {
                        finalLender.disbursalLenderInfoDetails[0].lenderAmount.payoutPercentage = ev;
                    }}
                    className="custom-input-number"
                    placeholder={((payoutDetails?.payoutSubtype?.toUpperCase() === "AMOUNT")) ? "₹" : "Payout %"}
                    min={0}
                    max={((payoutDetails?.payoutSubtype?.toUpperCase() === "PERCENTAGE")) ? 100 : undefined}
                />
            </Form.Item>
        ),
        <div style={{ display: "flex", justifyContent: "end", gap: "15px" }}>
            <Form.Item>
                <Button
                    className="next-btn button-submit dynamic-btn-default"
                    style={{ '--borderColor': appColors?.appSecondaryColor ?? "" } as any}
                    onClick={() => {
                        const tmpLender = { ...finalLender };
                        const disburselLenderInfo = [
                            ...tmpLender.disbursalLenderInfoDetails,
                        ];
                        disburselLenderInfo.splice(0, 1);
                        tmpLender.disbursalLenderInfoDetails = disburselLenderInfo;
                        setFinalLander(tmpLender)
                        setIsAddClick(false);
                        if (disburselLenderInfo?.length == 0) {
                            setIsAddCheck(false);
                        }
                    }}
                >Cancel</Button>
            </Form.Item>
            <Form.Item>
                <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    className={isMobile ? 'mobile-view-icon-btn' : 'next-btn dynamic-btn-primary'}
                    style={customStylesSubmitBtnPrimary}
                    icon={isMobile ? <IconAction /> : ''}
                >Submit</Button>
            </Form.Item>
        </div>
    ];

      const handleCancel = () => {
        setShowConfirmationPayout(false);
    };

    const confirmationPayout = () => {
        const customStylesBtnPrimary: any = { '--btnColor': appColors?.appPrimaryColor ?? "", width: "85px", height: "35px" };
        const customStylesBtn: any = { '--borderColor': appColors?.appSecondaryColor ?? "", width: "85px", height: "35px" };
        return (
            <Modal
                width={350}
                visible={showConfirmationPayout}
                style={{ marginBottom: 230 }}
                okText="Yes"
                cancelText="No"
                title=""
                centered
                closable={false}
                maskClosable={false}
                footer={false}
            >
                <div style={{ padding: "15px" }}>
                    <p style={{ fontSize: "17px" }}>
                    {payoutTypeFromAPI === "FIXED"
                            ? "This is a fixed payout. Are you sure you want to edit the payout?"
                            : "This is a slab-based payout. Are you sure you want to edit the payout?"}
                    </p>
                    <Space style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            type="primary"
                            className="dynamic-btn-primary"
                            style={customStylesBtnPrimary}
                            onClick={() => {
                                finalSubmit(finalValue);
                                setShowConfirmationPayout(false);
                            }}
                        >
                            OK
                        </Button>
                        <Button
                            style={customStylesBtn}
                            className="dynamic-btn-default"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Space>
                </div>
            </Modal>
        )
    }

    const actionSubmit = (value: any) => {
       if(leadData?.loanType !="Credit Card" || finalLender?.subProductDetails===null) {
        setIsLoading(true);
        finalLender.disbursalLenderInfoDetails[0].lenderAmount.disbursedBy= value?.disbursedBy
        if ((isTenantWorkingCapitalEnabled || isDocumentMendatory) && (uploadedFile?.businessDocumentId?.length ?? 0) == 0) {
            notification.error({ message: "Please Upload Disbursal Proof" })
        } else {
            finalLender.disbursalLenderInfoDetails[0].lenderAmount.proofOfDisbursalDto = uploadedFile ? {
                "documentIdList": [uploadedFile?.businessDocumentId]
            } : null;
            if (
                tenativePayoutFromAPI != null &&
                tenativePayoutFromAPI > 0 &&
                value?.payoutPercentage !== tenativePayoutFromAPI && value?.payoutPercentage != 0
            ) {
                setFinalValue(value);
                setShowConfirmationPayout(true);
                setIsLoading(false);
            } else {
                finalSubmit(value);
            }
        }
            
        }
        else{
            finalSubmit(value);
        }
        
    };

    const finalSubmit = (value: any) => {
        const infoEntity = finalLender?.disbursalLenderInfoDetails?.find(
            (item: any) => item?.disbursalId == null
        );

        const payoutValue = disbursedForm.getFieldValue("payoutPercentage");

        if (infoEntity && infoEntity.lenderAmount) {
            // Set only one of initialPayoutAmount or payoutPercentage based on payoutSubtype
            if (payoutDetails?.payoutSubtype?.toUpperCase() === "AMOUNT") {
                infoEntity.lenderAmount.initialPayoutAmount = value?.payoutPercentage ?? payoutValue;
                infoEntity.lenderAmount.payoutPercentage = undefined;
            } else {

                infoEntity.lenderAmount.initialPayoutAmount = undefined;
                infoEntity.lenderAmount.payoutPercentage = value?.payoutPercentage ?? payoutValue;
            }
            infoEntity.lenderAmount.payoutSubtype = payoutDetails?.payoutSubtype ?? "PERCENTAGE";
        }

        // const tmpLender = { ...finalLender, cardIssuedDate:value?.cardIssuedDate };
        const tmpLender = {
            ...finalLender,
            subProductDetails: {
              ...finalLender.subProductDetails,
              subProductDetails: finalLender.subProductDetails?.subProductDetails?.map((item) => ({
                ...item,
                cardIssuedDate: value?.cardIssuedDate ? moment(value?.cardIssuedDate).format("YYYY-MM-DD") :null,
              })),
            },
          };
        if(leadData?.loanType != "Credit Card" ||tmpLender?.subProductDetails === null ){
            tmpLender.disbursalLenderInfoDetails = null;
            tmpLender.disbursalLenderInfoEntity = [infoEntity];
            if (value?.payoutPercentage == 0) {
                setIsLoading(false);
                notification.error({
                    message:
                        "Please ensure that payout % are filled, this field will not be editable beyond this point.",
                });
                
            } else {
                setIsLoading(true);
                setIsAddClick(false);
                // setLoading(true);
                onActionSubmit(tmpLender, value?.comment);
            }
        }
        else{
            setIsLoading(true);
            onActionSubmit(tmpLender, value?.comment);
        }
       
    };
    return (
        
        <>
            <Form
                layout="vertical"
                form={disbursedForm}
                style={{ padding: "25px" }}
                onFinish={actionSubmit}
            >
                {(Object.keys(finalLender?.subProductDetails ?? {})?.length ?? 0) == 0 ? (
                    <List
                    grid={{ gutter: 16, column: 2 }}
                    dataSource={data}
                    renderItem={(item, index) => (
                        <List.Item>
                            {item}
                        </List.Item>
                    )}
                />
                ) :(
                    <>
                        <Row align="middle" gutter={12} style={{ width: '100%' }}>
                            <Col  span={6} xs={12} xl={6}>
                                <Text>{productPlanName}</Text>
                                <div style={{ display: isMobile ? "flex" : "grid" }} >
                                    {(finalLender?.subProductDetails?.subProductDetails?.at(0)?.applicationNumber?.length > 0 && leadData?.loanType === "Credit Card") ? (
                                        <span style={{ fontSize: "11px" }}>
                                        Application ID:{applicationNumber}&nbsp;
                                        {/* <img
                                        src={copy}
                                        alt=""
                                        width={11}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(payment?.disbursalId);
                                        }}
                                        /> */}
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                    
                                    </div>
                                    
                            </Col>
                            <Col  span={6} xs={12} xl={6}>
                                <Form.Item
                                name="cardIssuedDate"
                                label="Issued Date"
                                rules={[{ required: true }]}
                                style={{ marginBottom: 0 }}
                                >
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    disabledDate={disableDate}
                                    style={{ width: '100%' }}
                                    className="custom-input"
                                />
                                </Form.Item>
                            </Col>
                            <Col flex="none" style={{ marginLeft: 'auto' }}>
                                <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                icon={isMobile ? <IconAction /> : null}
                                className={isMobile ? 'mobile-view-icon-btn' : 'next-btn dynamic-btn-primary'}
                                style={customStylesSubmitBtnPrimary}
                                >
                                Submit
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
                {loaderForPayout && <AppLoading/>}
             </Form>
            {showConfirmationPayout && confirmationPayout()}
        </>
    )
};

export default AddDisbursed;